function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as o } from "./index.es33.js";
import { clsx as c } from "./index.es105.js";
import { Icon as m } from "./index.es7.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as s } from "./index.es36.js";
import { useControlColor as l } from "./index.es508.js";
import "react";
import "./index.es15.js";
import "./index.es172.js";
import i from "./index.es584.js";
var a = {
    active: s.blue6,
    hidden: s.gray6
  },
  T = function T(n) {
    return function (r) {
      var t = r.isVisibleDisabled,
        e = r.isAlwaysVisible,
        p = l({
          isAlwaysVisible: e,
          isVisibleDisabled: t,
          colorsConfig: a
        });
      return o.jsx(n, _objectSpread(_objectSpread({}, r), {}, {
        children: o.jsx("div", {
          className: c(i.iconContainer, _defineProperty({}, i.iconContainerDisabled, t)),
          children: o.jsx(m, {
            className: i.iconContainer,
            icon: m.icons.outline.info,
            color: p,
            size: 16
          })
        })
      }));
    };
  };
export { T as IconWithTooltipFactory };